module.exports = __webpack_public_path__ + "img/7.67ec4667.webp";